import { render, staticRenderFns } from "./GiftVendorList.vue?vue&type=template&id=2f668994&scoped=true&"
import script from "./GiftVendorList.vue?vue&type=script&lang=js&"
export * from "./GiftVendorList.vue?vue&type=script&lang=js&"
import style0 from "./GiftVendorList.vue?vue&type=style&index=0&id=2f668994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f668994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f668994')) {
      api.createRecord('2f668994', component.options)
    } else {
      api.reload('2f668994', component.options)
    }
    module.hot.accept("./GiftVendorList.vue?vue&type=template&id=2f668994&scoped=true&", function () {
      api.rerender('2f668994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/GiftVendorList.vue"
export default component.exports